import { Typography, Box } from "@mui/material";

export default function MetadataSidebar({ open, metadata }) {
    if (!open || !metadata) return null
    return (
        <Box sx={{position: 'absolute', top: 40, left: 60, bgcolor: 'rgba(0,0,0,0.6)', p: 1, width: '300px', zIndex: 1000 }}>
            <Typography variant="subtitle2">Details</Typography>
            <Box>
                {Object.entries(metadata).map(([key, value]) => (
                    <Box key={key}>
                        <Typography variant="body2" sx={{ opacity: 0.7, mb: 0.5, color: '#fff', wordBreak: 'break-word' }}>
                            {key}: {String(value)}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}


